
import React from 'react';
import { Progress } from "@/components/ui/progress";

interface PaymentProcessingStepsProps {
  processingStep: number;
  progressValue: number;
  processingSteps: string[];
}

const PaymentProcessingSteps: React.FC<PaymentProcessingStepsProps> = ({
  processingStep,
  progressValue,
  processingSteps
}) => {
  return (
    <div className="space-y-2">
      <Progress value={progressValue} className="h-2" />
      <p className="text-center text-sm text-gray-600">
        {processingSteps[processingStep] || "Finalizacja zamówienia..."}
      </p>
    </div>
  );
};

export default PaymentProcessingSteps;
